import styled from 'styled-components/macro';
import { mediumHeightScreens, mediumScreens, smallScreens } from 'components/common/fontElements';

export const LeftSection = styled.div`
  padding-right: 30px;
  color: #4697c3;
  font-size: 14px;
  font-weight: bold;
  @media (max-height: ${smallScreens}) {
    font-size: 14px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 13px;
  }
`;

export const RightSection = styled.div`
  flex: 1;
`;

export const StepContainer = styled.div`
  display: flex;
  padding-bottom: 50px;
`;

export const Link = styled.a`
  text-decoration: underline;
`;

export const ShippingLabelImage = styled.img`
  width: 100%;
  border: 1px solid #d0d0d0;
`;

export const InstructionsText = styled.p`
  font-family: Lato;
  font-size: 14px;
  color: #333333;
  margin-bottom: 30px;
  text-align: left;
  @media (max-height: ${smallScreens}) {
    font-size: 14px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 13px;
  }
`;

export const InstructionsTextContainer = styled.div`
  width: 80%;
`;

export const SubText = styled.p`
  font-family: Lato;
  font-size: 12px;
  color: #333333;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '0px')};
  margin-bottom: 12px;
  text-align: left;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 10px;
  }
`;

export const SearchOrdersContainer = styled.div`
  padding: 20px 30px 20px 30px;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  border-bottom: ${(props) => (props.isLoading ? 'none' : '1px solid rgb(183, 202, 211)')};

  & > * {
    padding: 5px;
    flex: 1 0;
  }
  @media (max-height: ${smallScreens}) {
    padding: 10px 30px 15px 30px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    padding: 10px 30px 10px 30px;
  }
`;

export const ResultsTable = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 300px;
`;

export const ResultCancelSubscriptionRow = styled.tr`
  flex: 1;
  color: #ffffff;
  cursor: pointer;
  background-color: ${(props) => (props.active ? '#CCEBDE' : 'white')};
  display: flex;
  border-bottom: 0.1rem solid #d8e8ef;
  align-items: center;

  & em {
    background-color: #a1b6a7;
    color: #fff;
    font-style: normal;
  }

  & td {
    padding: 20px 8px 20px 8px !important;
    vertical-align: top;
    border-top: 0 !important;
    @media (max-height: ${mediumHeightScreens}) {
      padding: 10px 8px 10px 8px !important;
    }
  }

  &:hover {
    background-color: ${(props) => (props.active ? '#CCEBDE !important' : 'white !important')};
  }
`;

export const InputContainer = styled.div`
  width: 100%;
  margin: 0px 10px 0px 0px;
  padding: 0px;
  flex-basis: 100%;
  @media (max-width: ${smallScreens}) {
    flex-basis: 100%;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  width: 100%;
`;

export const InnerContainer = styled.div`
  flex: 1;
  padding: 50px 0px 100px;
  width: 400px;
  text-align: center;
  margin: 0px auto;
  @media (max-width: ${mediumScreens}) {
    width: 300px;
  }
`;
